<template>
	<section class="block block-slider">
		<div class="block__headline">
			<div class="block__title headline-1">
				<i
					:class="titleIconClass"
					class="block__icon"
				></i>
				{{title}}
			</div>

			<div class="block__nav">
				<a
					v-if="subTitle && subTitleLink"
					:href="subTitleLink"
					class="headline-3">
					{{subTitle}}
				</a>
				<div class="block-slider__nav">
					<i
						@click="sliderPrev()"
						class="block-slider__nav-prev block__icon icon-arrow-left"
					></i>
					<i
						@click="sliderNext()"
						class="block-slider__nav-next block__icon icon-arrow-right"
					></i>
				</div>
			</div>
		</div>

		<Swiper
			style="width: 100%;"
			:slides-per-view="4"
			:space-between="25"
			:pagination="false"
			:navigation="{
				nextEl: '.' + $attrs.class + ' .block-slider__nav-next',
				prevEl: '.' + $attrs.class + ' .block-slider__nav-prev',
			}"
			:breakpoints="{
				0: {
					slidesPerView: 1,
				},
				512: {
					slidesPerView: 2,
				},
				900: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				}
			}"
			:modules="modules"
			@swiper="onInitSwiper">
			<SwiperSlide
				:key="item.name + index"
				v-for="(item, index) in items">
				<BlockCardCollection v-if="typeCard === 'collection'" :item="item"/>
				<BlockCardEvent v-else-if="typeCard === 'event'" :item="item"/>
			</SwiperSlide>
		</Swiper>
	</section>
</template>

<script>
import BlockCardCollection from '@/components/cards/CardEvent/BlockCardCollection.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

export default {
	name: 'SliderQuarto',
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		title: {
			type: String,
			default: 'Default Title'
		},
		titleIconClass: {
			type: String,
			default: 'icon-grp-5'
		},
		subTitle: {
			type: String,
			default: null
		},
		subTitleLink: {
			type: String,
			default: null
		},
		sliderItemComponent: {
			type: String,
			default: 'BlockCardCollection'
		},
		typeCard: {
			type: String,
			default: 'collection'
		},
		items: {
			type: Array,
			default: () => []
		}
	},
	setup() {
		return {
			modules: [Navigation],
		};
	},
	data() {
		return {
			swiper: null
		}
	},
	methods: {
		onInitSwiper(swiper) {
			// console.log(swiper, tab);
			this.swiper = swiper;
		},
		sliderNext() {
			// this.$refs['swiper-container'].swiper.slideNext();
			this.swiper.slideNext();
		},
		sliderPrev() {
			this.swiper.slidePrev();
		},
	},
};

</script>
